// extracted by mini-css-extract-plugin
export var dataHeadings = "styles-module__dataHeadings___G77cA";
export var splitsBar = "styles-module__splitsBar___kLCcz";
export var splitsData = "styles-module__splitsData___UNr1J";
export var splitsPace = "styles-module__splitsPace___x6rhx";